import { Trans } from '~/common/context';
import { Button, Dropdown, Icon, SelectErrorIndicator } from '@wyz/ui';
import { useManageCriteria } from '~/common/api';
import { ICriteria, ICriteriaVisibilityFilter } from '~/connect/types';

type NewCriteriaSelectProps = {
  onAdd: (criterion: ICriteria) => void;
  criteriaIds: Array<ICriteria['id']>;
  disabled?: boolean;
  visibilityFilter?: ICriteriaVisibilityFilter;
};
const NewCriteriaSelect = ({
  onAdd,
  criteriaIds,
  disabled,
  visibilityFilter,
}: NewCriteriaSelectProps) => {
  const manageCriteria = useManageCriteria({
    getAll: {
      enabled: true,
      args: visibilityFilter,
      placeholderData: (previousData) => previousData,
    },
  });
  return (
    <>
      {manageCriteria.getAll.isError && (
        <SelectErrorIndicator
          label={
            <Trans i18nKey='app.supplier_template.form.criteria.new_criteria_label' />
          }
          message={<Trans i18nKey='app.common.select_field.options_error' />}
        />
      )}
      <Dropdown.Container>
        <Dropdown.Toggle bsPrefix='toggle' as='div' id='add-criteria-toggler'>
          <Button
            id='add-criteria'
            onClick={() => {}}
            variant='tertiary-blue'
            disabled={!manageCriteria.getAll.isSuccess || disabled}
          >
            {!manageCriteria.getAll.isSettled ? (
              <Icon icon='spinner' size='xs' />
            ) : (
              <Icon icon='plus' size='xs' />
            )}
            <Trans i18nKey='app.supplier_template.form.criteria.add_criteria' />
          </Button>
        </Dropdown.Toggle>

        {manageCriteria.getAll.isSuccess && (
          <Dropdown.Menu className='dropdown-caret dropdown-menu-card  dropdown-menu-end'>
            {manageCriteria.getAll.data.data
              .filter(
                (criterion) =>
                  criterion.available !== false &&
                  !criteriaIds.includes(criterion.id),
              )
              .map((criterion) => (
                <Dropdown.Item
                  key={criterion.id}
                  as='button'
                  type='button'
                  className='fs-normal'
                  onClick={() => {
                    onAdd(criterion);
                  }}
                  id={criterion.name}
                >
                  {criterion.translatedName ?? criterion.name}
                </Dropdown.Item>
              ))}
          </Dropdown.Menu>
        )}
      </Dropdown.Container>
    </>
  );
};

export default NewCriteriaSelect;
